import React, {Component} from 'react';
import {Button, Icon} from 'semantic-ui-react';

const buildFileSelector = (supportedFiles) => {
  const fileSelector = document.createElement('input');
  fileSelector.setAttribute('type', 'file');
  fileSelector.setAttribute('accept', supportedFiles);

  return fileSelector;
};

class FileUpload extends Component {
  constructor(props) {
    super(props);
    this.state = { };

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const {name, supportedFiles, multiple, changeActions} = this.props;

    this.fileSelector = buildFileSelector(supportedFiles);
    this.fileSelector.onchange = changeActions;
    this.fileSelector.multiple = multiple;
    this.fileSelector.name = name;
  }

  handleClick(event) {
    event.preventDefault();
    this.fileSelector.click();
  }

  renderIcon() {
    if (this.props.icon) {
      return (<Icon name='upload' />);
    }

    return null;
  }

  render() {
    const {text, disabled, loading} = this.props;
    const clickActions = disabled ? null : this.handleClick;

    return (
      <Button primary
        onClick={clickActions}
        disabled={disabled}
        loading={loading}
      >
        {this.renderIcon()}
        {text}
      </Button>
    );
  }
}

export default FileUpload;
